import React from 'react';
import { useSelector } from 'react-redux';

import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';
import { IconText } from '@travel/ui';
import { cx, isEmptyArray, isNotEmptyArray } from '@travel/utils';

import { mappedIconTextListData } from 'pages/ProviderInformationPage/helpers';

import { getItem } from 'store/providerInformation/selectors';

import { Translate } from 'core/translate';

import styles from './overview.module.scss';

type Props = {};

function OverviewPropertyFacilities(props: Props) {
  const provider = useSelector(getItem);

  const isMobile = useDeviceType() === MOBILE_SCREEN;

  // filter with below 2 groups, convert to flat features array,
  // convert icon to react node, slice to 4 for 2 x 2 grid
  // groups => facility management. Look for `FeatureManagementNames` in API code for a list of all possible options
  // groups are lower level and can have any name, will also change based on language
  const allowedOverviewFacilityManagements = ['Facility', 'Service'];
  const filteredOverviewFacilityManagements = provider.facilities?.filter(facility =>
    allowedOverviewFacilityManagements.includes(facility?.management),
  );

  let overviewFacilities = filteredOverviewFacilityManagements?.reduce(
    (result: Array<any>, facility) => {
      // TODO: fix TS mess
      const features = mappedIconTextListData(facility.features, styles.featureIcon) as Array<any>;

      if (isEmptyArray(features)) {
        return result;
      }
      return [...result, ...features];
    },
    [],
  );
  overviewFacilities = overviewFacilities.slice(0, isMobile ? 4 : 6);

  return isNotEmptyArray(overviewFacilities) ? (
    <div
      className={cx(styles.overviewInfoContainer, styles.overviewFacilitiesWrapper)}
      data-testid="providerInformation-overview-overviewPropertyFacilities"
    >
      <h3 className={cx(styles.subTitle, styles.blockTitle)}>
        <Translate id="Provider_Info.Basic_Info.Hotel_Info.Features.Hotel" />
      </h3>

      <div data-testid="providerInformation-overview-overviewPropertyFacilities-facilityGrid">
        <ul className={styles.facilityGrid}>
          {overviewFacilities.map(facility => (
            <li
              key={facility.id || facility.text}
              className={cx(styles.featureSize, styles.itemWrapper)}
            >
              <IconText spaceBetween={4} {...facility} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
}

export default OverviewPropertyFacilities;
